import { LoaderFnConfig } from '@frontend/loaders';
import { ClientConfigProductName } from '@frontend/vanilla/core';

export const CrmPromotionWidgetLoader: LoaderFnConfig = {
    id: 'crm-promotion-widget',
    loaderFn: () => import('./crm-promotion-widget.feature'),
    product: ClientConfigProductName.SPORTS,
};
